export default "__VITE_ASSET__DHy$jGuP__"